export const red="#D90000";
export const grey="#E4E4E4";
export const pink="#F7CCCC";
// {"name":"Hydrogrund Plus","url":"https://www.amonncolor.com/wp-content/uploads/2021/07/Hydrogrund-Plus-25lt.jpg","product_line":"lignex"}